/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

/**
 * Attaches a given access token to a MS Graph API call. Returns information about the user
 * @param accessToken
 */
export async function callMsGraph(accessToken: string, endpoint: string) {
  const headers = new Headers();
  const bearer = `Bearer ${accessToken}`;

  headers.append("Authorization", bearer);
  //headers.append("Access-Control-Allow-Origin", "*");
  const options = {
    //mode: "no-cors",
    method: "GET",
    headers: headers,
  };
  return fetch(endpoint, options)
    .then(response => response.json())
    .catch(error => console.log(error));
}


